module.exports = __webpack_public_path__ + "img/yfi.1ac4b34e.svg";